import CloudDownloadOutlined from "@ant-design/icons/es/icons/CloudDownloadOutlined";
import { Button, ButtonProps } from "antd";

/**
 * Button formatted to be a proper download link.
 */
export const DownloadButton = ({
  children,
  icon,
  ...props
}: ButtonProps) => {
  return <Button icon={icon ?? <CloudDownloadOutlined />} {...props} data-sentry-element="Button" data-sentry-component="DownloadButton" data-sentry-source-file="DownloadButton.tsx">
      {children}
    </Button>;
};